// 每用户唯一背景:由 userId 推导色相,双 radial + linear 渐变
export function userBackground(userId: number): string {
  const hue = ((userId * 47) % 360 + 360) % 360;
  const h2 = (hue + 40) % 360;
  return `radial-gradient(circle at 20% 20%, hsla(${hue},60%,70%,0.18), transparent 45%),
          radial-gradient(circle at 80% 60%, hsla(${h2},60%,65%,0.15), transparent 50%),
          linear-gradient(135deg, hsl(${hue},22%,97%), hsl(${h2},20%,93%))`;
}
